import { Component, Element, Prop, h } from '@stencil/core';

import landingActions from '../actions/actions.landing-oem';
import { actions as pageParamsActions } from '../actions/actions.page-params';
import { state as cobrandingState, on as onCobrandingStateChange } from '../store/store.cobranding';
import { state as landingState, on as onLandingStateChange } from '../store/store.landing';
import { DynamicEntryInstallationMode } from '../utils/utils.dynamic-entry';
import { DynamicEntryWorkflow } from '../utils/utils.landing';
import { DEFAULT, GetLandingOemSubheader } from '../utils/utils.landing-oem';

@Component({
  tag: 'ico-landing-oem-hydrator',
})
export class LandingOEMHydrator {
  @Element() el: HTMLElement;
  @Prop() dynamicEntryWorkflow: DynamicEntryWorkflow = DynamicEntryWorkflow.OEM;
  @Prop() installationMode?: DynamicEntryInstallationMode;
  @Prop() tabList: string[] = DEFAULT.TAB_LIST;
  @Prop() theme?: string = '';
  @Prop() inputVin: string = '';
  @Prop() mileage?: number;
  @Prop() dealerId: string = '';
  @Prop() dealerGroupId: string = '';
  @Prop() cobrandingGroupId: string = '';

  // Analytics
  @Prop() offerCode: string = '';
  @Prop() lnxCode: string = '';
  @Prop() entry: string = '';
  @Prop() category: string = '';

  async componentWillRender() {
    landingActions.onReceivedParams({
      offerCode: this.offerCode,
      installationMode: this.installationMode,
      category: this.category,
      dealerId: this.dealerId,
      dealerGroupId: this.dealerGroupId,
    });
    pageParamsActions.onReceivedParams({ entry: this.entry, offerCode: this.offerCode, lnxCode: this.lnxCode, category: this.category });

    await landingActions.onOptimizelyFetching();
    this.setupStateProps();
    onLandingStateChange('set', (prop, value) => {
      this.updateStateProps(prop, value);
    });

    onLandingStateChange('reset', () => {
      this.setupStateProps();
    });

    onCobrandingStateChange('set', (prop, value) => {
      this.updateStateProps(prop, value);
    });
  }

  // updates only the changed prop
  updateStateProps(prop, value) {
    this.el.childNodes.forEach((element) => {
      if (element.hasChildNodes) {
        element.childNodes.forEach((elementChild) => {
          elementChild[prop] = value;
        });
      }
    });
  }
  // explicitly declare initial state props
  setupStateProps() {
    landingState.oem.heading = DEFAULT.HEADING;
    landingState.oem.subheading = GetLandingOemSubheader(this.theme);
    this.el.childNodes.forEach((element) => {
      element['dynamicEntryWorkflow'] = this.dynamicEntryWorkflow;
      element['offerCode'] = landingState.offerCode;
      element['installationMode'] = landingState.installationMode;
      element['legalContents'] = landingState.legalContents.oem;
      element['heading'] = landingState.oem.heading;
      element['subheading'] = landingState.oem.subheading;
      element['theme'] = this.theme;
      element['imageUrl'] = cobrandingState.imageUrl;
      element['inputVin'] = this.inputVin;
      element['mileage'] = this.mileage;
      element['dealerId'] = this.dealerId;
      element['dealerGroupId'] = this.dealerGroupId;
      element['cobrandingGroupId'] = this.cobrandingGroupId;
    });
  }

  render() {
    return (
      <div class="hydration-state hydration-state--landing-oem">
        <slot />
      </div>
    );
  }
}
